import {DateTime} from 'luxon';

export function dateObjectToISOString(dateObject: { year: number, month: number, day: number } | string): string {
  return typeof dateObject === 'string' ? dateObject : DateTime.fromObject(dateObject).toISO();
}
